import * as React from 'react';

import { observer } from 'mobx-react';

import { ITranslationsCollection } from '@estee/elc-service';
import { RAMP_SIGN_IN_SIGN_UP } from '@estee/elc-service-view-names';

import { VulcanContext } from '~context/VulcanContext';
import { IRampPreloadedConfig } from '~domain/entities/Config';
import { PageNotLoaded } from '~views/PageNotLoaded';
import { RampMain } from '~views/RampMain';

import { RampSignInSignUpViewController } from './RampSignInSignUpViewController';

export interface IRampSignInSignUpProps {
    config: IRampPreloadedConfig;
    viewController: RampSignInSignUpViewController;
    translations: ITranslationsCollection;
}

@observer
class RampSignInSignUp extends React.Component<IRampSignInSignUpProps> {
    async componentDidMount() {
        await this.props.viewController.loaded();
    }

    componentWillUnmount() {
        this.props.viewController.dispose();
    }

    render() {
        const {
            data: { hasError, isLoading }
        } = this.props.viewController;

        return (
            <VulcanContext translations={this.props.translations} config={this.props.config}>
                {hasError ? (
                    <PageNotLoaded />
                ) : (
                    <RampMain isLoading={isLoading} serviceViewName={RAMP_SIGN_IN_SIGN_UP} />
                )}
            </VulcanContext>
        );
    }
}

export default RampSignInSignUp;
